<template>
  <x-card title="选择售后服务" class="service">
    <div
      v-if="$state.supportAfterSalesTypes.includes(AfterSalesType.退款)"
      v-track="{
        name: '申请售后-选择售后服务-仅退款',
        id: '4b3f73aa-9ffc-4299-ae38-f1aaab3a8ae7',
      }"
      class="item"
      @click="navigateToSubmit(AfterSalesType.退款)"
    >
      <img class="icon" :src="require('./images/退款.png')" />
      <div class="content">
        <div class="title">我要退款（无需退货）</div>
        <div class="desc">商家未发货，或与平台协商同意退款</div>
      </div>
      <van-icon name="arrow" class="arrow" />
    </div>

    <div
      v-if="
        $state.supportAfterSalesTypes.includes(AfterSalesType.退货退款) &&
        $state.delivered
      "
      v-track="{
        name: '申请售后-选择售后服务-退货退款',
        id: '7f56b8f5-d10a-47f4-b1af-924e57189570',
      }"
      class="item"
      @click="navigateToSubmit(AfterSalesType.退货退款)"
    >
      <img class="icon" :src="require('./images/退货退款.png')" />
      <div class="content">
        <div class="title">我要退货退款</div>
        <div class="desc">已收到货，需要退还收到的货物</div>
      </div>
      <van-icon name="arrow" class="arrow" />
    </div>

    <div
      v-if="
        $state.supportAfterSalesTypes.includes(AfterSalesType.换货) &&
        $state.delivered
      "
      v-track="{
        name: '申请售后-选择售后服务-换货',
        id: 'cd2b5248-3b9b-45ce-b29a-313907a40c1a',
      }"
      class="item"
      @click="navigateToSubmit(AfterSalesType.换货)"
    >
      <img class="icon" :src="require('./images/换货.png')" />
      <div class="content">
        <div class="title">换货</div>
        <div class="desc">商品存在质量问题，联系卖家协商换货</div>
      </div>
      <van-icon name="arrow" class="arrow" />
    </div>
  </x-card>
</template>

<script>
  import Vue from 'vue'
  import { afterSalesBus, AfterSalesType } from '../_model'
  import { afterSalesModel } from './_model'
  import { mapQuery, Track } from '@/utils'
  import { navigateBack, navigateTo, redirectTo } from '@/router'

  export default Vue.extend({
    mixins: [
      afterSalesModel.mixin,
      mapQuery({
        // 重新申请时传入的售后 ID
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '选择售后服务',
      })),
    ],

    data: () => ({ AfterSalesType }),

    activated() {
      if (afterSalesModel.state.afterSalesId) {
        // 是重新申请的
        if (this.id) {
          afterSalesBus.emit(
            'updateDetailId',
            afterSalesModel.state.afterSalesId,
          )
          navigateBack()
        } else {
          redirectTo('AfterSalesDetail', {
            id: afterSalesModel.state.afterSalesId,
          })
        }
        afterSalesModel.update({
          afterSalesId: '',
        })
      }
    },

    methods: {
      navigateToSubmit(type) {
        navigateTo('AfterSalesRequestSubmit', {
          commodityId: afterSalesModel.state.goodsId,
          skuId: afterSalesModel.state.skuId,
          orderNo: afterSalesModel.state.orderNo,
          type: type,
          id: this.id,
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .service {
    .item {
      display: flex;
      align-items: center;

      &:not(:first-child) {
        margin-top: 16px;
      }

      &:active {
        opacity: 0.8;
      }

      .icon {
        flex-shrink: 0;
        width: 28px;
        height: 28px;
      }

      .content {
        margin-left: 12px;
        flex-grow: 1;

        .title {
          font-size: 14px;
          font-weight: bold;
          color: #222222;
        }

        .desc {
          margin-top: 2px;
          font-size: 12px;
          color: #888888;
        }
      }

      .arrow {
        flex-shrink: 0;
        font-size: 14px;
        color: #bebebe;
      }
    }
  }
</style>
